// eslint-disable-next-line es/no-classes
export class NotFoundError extends Error {
    constructor(message = 'Resource not found') {
        super(message);
        this.name = 'NotFoundError';
        this.responseStatus = 404;
    }
}
